/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCurrentUserDetails = /* GraphQL */ `
  query GetCurrentUserDetails {
    getCurrentUserDetails
  }
`;
export const getOrgDetails = /* GraphQL */ `
  query GetOrgDetails {
    getOrgDetails
  }
`;
export const getSystemHealth = /* GraphQL */ `
  query GetSystemHealth {
    getSystemHealth
  }
`;
export const ListOrgUsers = /* GraphQL */ `
  query ListOrgUsers($input: ListOrgUsersInput) {
    ListOrgUsers(input: $input)
  }
`;
export const listCallHistory = /* GraphQL */ `
  query ListCallHistory($input: listCallHistoryInput) {
    listCallHistory(input: $input)
  }
`;
export const getCallFeedback = /* GraphQL */ `
  query GetCallFeedback($input: getCallFeedbackInput) {
    getCallFeedback(input: $input)
  }
`;
export const getPlatformDisclaimerDefault = /* GraphQL */ `
  query GetPlatformDisclaimerDefault {
    getPlatformDisclaimerDefault
  }
`;
export const getDasbBoardData = /* GraphQL */ `
  query GetDasbBoardData($input: getDasbBoardDataInput) {
    getDasbBoardData(input: $input)
  }
`;
export const getDashboardInsights = /* GraphQL */ `
  query GetDashboardInsights($input: getDashboardInsightsInput) {
    getDashboardInsights(input: $input)
  }
`;
export const listContactUs = /* GraphQL */ `
  query ListContactUs($input: listContactUsInput) {
    listContactUs(input: $input)
  }
`;
export const listOrgTransactions = /* GraphQL */ `
  query ListOrgTransactions($input: listOrgTransactionsInput) {
    listOrgTransactions(input: $input)
  }
`;
export const listCreditRequests = /* GraphQL */ `
  query ListCreditRequests($input: listCreditRequestsInput) {
    listCreditRequests(input: $input)
  }
`;
export const getUniqueCallerStats = /* GraphQL */ `
  query GetUniqueCallerStats($input: getUniqueCallerStatsInput) {
    getUniqueCallerStats(input: $input)
  }
`;
export const listOutboundActions = /* GraphQL */ `
  query ListOutboundActions($input: listOutboundActionsInput) {
    listOutboundActions(input: $input)
  }
`;
export const getOnCallAction = /* GraphQL */ `
  query GetOnCallAction($input: getOnCallActionInput) {
    getOnCallAction(input: $input)
  }
`;
export const listOnCallActions = /* GraphQL */ `
  query ListOnCallActions($input: listOnCallActionsInput) {
    listOnCallActions(input: $input)
  }
`;
export const listSlotResources = /* GraphQL */ `
  query ListSlotResources($input: ListSlotResourcesInput) {
    listSlotResources(input: $input)
  }
`;
export const listSlotBookings = /* GraphQL */ `
  query ListSlotBookings($input: ListSlotBookingsInput) {
    listSlotBookings(input: $input)
  }
`;
export const testOnCallAction = /* GraphQL */ `
  query TestOnCallAction($input: testOnCallActionInput) {
    testOnCallAction(input: $input)
  }
`;
export const getActionTemplate = /* GraphQL */ `
  query GetActionTemplate($input: getActionTemplateInput) {
    getActionTemplate(input: $input)
  }
`;
export const testOnCallNotification = /* GraphQL */ `
  query TestOnCallNotification($input: testOnCallNotificationInput) {
    testOnCallNotification(input: $input)
  }
`;
export const getTestCallResult = /* GraphQL */ `
  query GetTestCallResult($input: getTestCallResultInput) {
    getTestCallResult(input: $input)
  }
`;
export const listContexts = /* GraphQL */ `
  query ListContexts($input: listContextsInput) {
    listContexts(input: $input)
  }
`;
export const listLeads = /* GraphQL */ `
  query ListLeads($input: listLeadsInput) {
    listLeads(input: $input)
  }
`;
export const listBulkLeadUploads = /* GraphQL */ `
  query ListBulkLeadUploads($input: listBulkLeadUploadsInput) {
    listBulkLeadUploads(input: $input)
  }
`;
export const getLeadShard = /* GraphQL */ `
  query GetLeadShard($input: getLeadShardInput!) {
    getLeadShard(input: $input)
  }
`;
export const listContextCallHistory = /* GraphQL */ `
  query ListContextCallHistory($input: listContextCallHistoryInput!) {
    listContextCallHistory(input: $input)
  }
`;
export const getMySoftphoneRegistration = /* GraphQL */ `
  query GetMySoftphoneRegistration {
    getMySoftphoneRegistration
  }
`;
export const listTasks = /* GraphQL */ `
  query ListTasks {
    listTasks
  }
`;
export const myTasks = /* GraphQL */ `
  query MyTasks {
    myTasks
  }
`;
export const getTaskLeads = /* GraphQL */ `
  query GetTaskLeads($input: getTaskLeadsInput!) {
    getTaskLeads(input: $input)
  }
`;
export const getTaskAssignmentUploadStatus = /* GraphQL */ `
  query GetTaskAssignmentUploadStatus(
    $input: getTaskAssignmentUploadStatusInput!
  ) {
    getTaskAssignmentUploadStatus(input: $input)
  }
`;
export const listTeamMembers = /* GraphQL */ `
  query ListTeamMembers {
    listTeamMembers
  }
`;
export const getLeadHistory = /* GraphQL */ `
  query GetLeadHistory($input: getLeadHistoryInput!) {
    getLeadHistory(input: $input)
  }
`;
export const getLeadBehaviorProfile = /* GraphQL */ `
  query GetLeadBehaviorProfile($input: getLeadBehaviorProfileInput!) {
    getLeadBehaviorProfile(input: $input)
  }
`;
export const getLeadCallHistory = /* GraphQL */ `
  query GetLeadCallHistory($input: getLeadCallHistoryInput!) {
    getLeadCallHistory(input: $input)
  }
`;
export const suggestLeadColumnMapping = /* GraphQL */ `
  query SuggestLeadColumnMapping($input: suggestLeadColumnMappingInput!) {
    suggestLeadColumnMapping(input: $input)
  }
`;
export const getTaskMetrics = /* GraphQL */ `
  query GetTaskMetrics($input: getTaskMetricsInput!) {
    getTaskMetrics(input: $input)
  }
`;
export const getTaskMetricsDrilldown = /* GraphQL */ `
  query GetTaskMetricsDrilldown($input: getTaskMetricsDrilldownInput!) {
    getTaskMetricsDrilldown(input: $input)
  }
`;
export const getTaskStatusMetrics = /* GraphQL */ `
  query GetTaskStatusMetrics($input: getTaskStatusMetricsInput!) {
    getTaskStatusMetrics(input: $input)
  }
`;
export const getScopeMetrics = /* GraphQL */ `
  query GetScopeMetrics($input: getScopeMetricsInput!) {
    getScopeMetrics(input: $input)
  }
`;
export const getScopeMetricsDrilldown = /* GraphQL */ `
  query GetScopeMetricsDrilldown($input: getScopeMetricsDrilldownInput!) {
    getScopeMetricsDrilldown(input: $input)
  }
`;
export const getScopeStatusMetrics = /* GraphQL */ `
  query GetScopeStatusMetrics($input: getScopeStatusMetricsInput!) {
    getScopeStatusMetrics(input: $input)
  }
`;
export const startReportExport = /* GraphQL */ `
  query StartReportExport($input: startReportExportInput!) {
    startReportExport(input: $input)
  }
`;
export const getReportExportStatus = /* GraphQL */ `
  query GetReportExportStatus($input: getReportExportStatusInput!) {
    getReportExportStatus(input: $input)
  }
`;
export const retrieveFromKnowledgeBase = /* GraphQL */ `
  query RetrieveFromKnowledgeBase($input: retrieveFromKnowledgeBaseInput) {
    retrieveFromKnowledgeBase(input: $input)
  }
`;
export const searchKnowledgeBase = /* GraphQL */ `
  query SearchKnowledgeBase($input: searchKnowledgeBaseInput) {
    searchKnowledgeBase(input: $input)
  }
`;
// Campaign-wide dial-attempt log -- every dial (connected or not), unlike
// listCallHistory above which only ever returns calls that connected. Same
// bare-AWSJSON, optional-input shape as listCallHistory (no schema change
// needed server-side).
export const listTaskDialAttempts = /* GraphQL */ `
  query ListTaskDialAttempts($input: listTaskDialAttemptsInput) {
    listTaskDialAttempts(input: $input)
  }
`;
